import React from 'react'
import { View, Platform } from 'react-native'
import PropTypes from 'prop-types'
// eslint-disable-next-line import/no-unresolved
import CheckBox from '@react-native-community/checkbox'

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../VfText'

import styles, { checkBoxTintcolors } from './PreferenceItem.Styles'

const values = {
    'ON': true,
    'OFF': false
}

const rvalues = {
    true: 'ON',
    false: 'OFF'
}

const requiredIndicator = {
    required: '* ',
    optional: '',
    undefined: ''
}

function PreferenceItem(props) {

    const {
        id,
        necessity,
        withCheckBox,
        value,
        onValueChange,
        label,
        labelPlaceholders,
        labelStyle,
        desc,
        descPlaceholders,
        descStyle,
        style
    } = props

    return (
        <View style={style}>
            <VfText
                placeHolders={descPlaceholders}
                i18nKey={(requiredIndicator[necessity] || '') + desc}
                // color={Colors.smoothGrey}
                style={descStyle}
            />
            <View style={styles.checkBoxContainer}>
                {withCheckBox && (
                    <CheckBox
                        value={values[value]}
                        onValueChange={newValue => onValueChange(id, rvalues[newValue])}
                        disabled={false}
                        tintColors={checkBoxTintcolors}
                        boxType="square"
                        tintColor={Colors.veryLightPinkTwo}
                        onTintColor={Colors.white}
                        onCheckColor={Colors.white}
                        onFillColor={Colors.ocean}
                        onAnimationType="bounce"
                        offAnimationType="bounce"
                        style={{
                            ...Platform.select({
                                ios: styles.iosCheckBoxStyle,
                                android: styles.androidCheckBoxStyle
                            })
                        }}

                    />
                )}
                {label && (
                    <VfText
                        style={[styles.label, labelStyle]}
                        placeHolders={labelPlaceholders}
                        i18nKey={label || ''}
                    />
                )}
            </View>
        </View>
    )
}

PreferenceItem.defaultProps = {
    withCheckBox: true,
    value: 'OFF',
    onValueChange: () => { },
    necessity: undefined
}

PreferenceItem.propTypes = {
    id: PropTypes.string,
    necessity: PropTypes.string,
    withCheckBox: PropTypes.bool,
    value: PropTypes.bool,
    onValueChange: PropTypes.func,
    label: PropTypes.string,
    labelPlaceholders: PropTypes.array,
    labelStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    desc: PropTypes.string,
    descPlaceholders: PropTypes.array,
    descStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    style: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ])
}

export default PreferenceItem
